// extracted by mini-css-extract-plugin
export default {"radioInner":"ukw9e","container":"mBbO0","box":"a9dCH","title":"xF4Qt","continueBtn":"tas1E"};